import { useEffect } from 'react';

export default function PrivacyPage() {
  useEffect(() => {
    window.location.href = '/privacy';
  }, []);

  return null;
}
